module.exports = __webpack_public_path__ + "img/find-me.48ebe392.jpg";